export class UrlSiteAliasBase {
  public practice_id: string;
  public site_id: string;
  public alias: string;
  public owned_brand_id?: string;
  public colour?: string;
  public logo_url?: string;
}
